<template>
	<div class="web-push__wrap">
		<div class="web-push__wrap-content">
			<div v-if="page !== 'main-page'" class="web-push" :class="{'style2': computedWebpushStyle === 2}">
				<div class="web-push__text">
					<h2
						class="web-push__headline"
						:class="{'style2': computedWebpushStyle === 2}">
						Хотите, пришлем вам	уведомление о статусе вашей заявки?
					</h2>
					<div class="web-push__actions">
						<Button class="web-push__subscribe button--webpush-sub" :disabled="subscribeLoading" :handler="subscribe">Да, хочу</Button>
						<Button class="web-push__later button--webpush-later" :disabled="subscribeLoading" :class="{'style2': computedWebpushStyle === 2}" :handler="closeWebpush">Позже</Button>
					</div>
				</div>
				<div class="web-push__image">
					<picture v-if="computedWebpushStyle === 1">
						<source srcset="./web-push1-sm.svg" media="(max-width: 990px)">
						<img src="./web-push1.svg" alt="">
					</picture>
					<picture v-else>
						<source srcset="./web-push2-sm.svg" media="(max-width: 990px)">
						<img src="./web-push2.svg" alt="">
					</picture>
				</div>
			</div>
			<div v-else-if="page === 'main-page'">
				<Teleport to="body">
					<Modal :show="computedShowWebPush" @close="closeContractModal" class="web-push-akcii">
						<template #header></template>
						<template #icon></template>
						<template #body>
							<img class="web-push-akcii__image" src="./webpush-contract-akcii.svg" alt="">
							<h1 class="web-push-akcii__headline">Хотите узнавать о наших акциях первым?</h1>
							<p class="web-push-akcii__details">Мы расскажем о наших бонусах и спецпредложениях, а про снижение ставки вы узнаете в числе первых 🚀</p>
							<div class="web-push-akcii__actions">
								<Button class="button--web-push-akcii" :disabled="subscribeLoading" :handler="subscribe">Получать уведомления</Button>
							</div>
						</template>
						<template #footer></template>
					</Modal>
				</Teleport>
			</div>
			<Teleport to="body">
				<ModalCenter :show="webpushSubcribeError" @close="webpushSubcribeError = false" :show-cross-to-close="true" class="webpush-error">
					<template #header></template>
					<template #icon></template>
					<template #body>
						<h1 class="webpush-error__headline">Вы отклонили запрос системы на показ уведомлений в браузере</h1>
						<p class="webpush-error__details">Вам необходимо разрешить сайту присылать вам уведомления в настройках браузера. Ознакомиться подробнее как это сделать можно <a target="_blank" href="https://yandex.ru/support/common/browsers-settings/notifications.html">здесь.</a></p>
						<div class="webpush-error__actions">
							<Button :handler="() => webpushSubcribeError = false" class="button--webpush-error">Понятно</Button>
						</div>
					</template>
					<template #footer></template>
				</ModalCenter>
			</Teleport>
		</div>
	</div>
</template>

<script setup>

import {
	computed, onMounted, ref,
} from 'vue';

import Button from '@/shared/components/Button/Button.vue';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { useStore } from 'vuex';
// import { useStorage } from '@vueuse/core/index';
import { clearCookie, setCookie } from '@/shared/lib/helpers/cookies';
import { useStorage } from '@vueuse/core';
import ModalCenter from '@/shared/components/ModalCenter/ModalCenter.vue';
import Modal from '@/shared/components/Modal';
import { useRouter } from 'vue-router';

// eslint-disable-next-line no-undef
const emit = defineEmits(['closeWebpush', 'webpushAfterResetToken']);
// eslint-disable-next-line no-undef
defineProps(['computedShowWebPush']);
const store = useStore();
const router = useRouter();

const page = computed(() => router.currentRoute.value.name);
// const firebaseToken = ref(undefined);
// const subsriptionUid = ref(null);
// const callFbTokenOnInit = useStorage('callFbTokenOnInit', false);
const fbToken = useStorage('fbToken', null);
// const subscriptionUid = useStorage('subscriptionUid', null);
const webpushSubcribeError = ref(false);

/*
* В зависмости от timestamp создания заявки показываем 1 или 2 плашку
* */
const computedWebpushStyle = computed(() => {
	const loanCreatedAtTimestamp = +new Date(store.state.loan?.created_at);
	return loanCreatedAtTimestamp % 2 === 0 ? 1 : 2;
});

const firebaseConfig = JSON.parse(JSON.parse(JSON.stringify(process.env.VUE_APP_FIREBASECONFIG)));
const vapidKeyMax = process.env.VUE_APP_VAPIDKEYMAX;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
const messaging = getMessaging(app);

// Закрытие плашки с сохранением данных о закрытии в localStorage
const closeWebpush = (setcookie = true) => {
	emit('closeWebpush');
	emit('webpushAfterResetToken', false);
	if (setcookie) {
		setCookie('webPushHidden', true, { expires: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 14) });
	}
	webpushSubcribeError.value = false;
};

const closeContractModal = () => {
	emit('closeWebpush');
	emit('webpushAfterResetToken', false);
	setCookie('contractModal', false, { expires: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 14) });
};

// eslint-disable-next-line no-unused-vars
// async function unsubscribe() {
// 	// const resp = await store.dispatch('webPush/unsubscribe', subsriptionUidStorage.value);
// 	const resp = await store.dispatch('webPush/unsubscribe', subscriptionUid.value);
// 	console.log('unsubscribe:', resp);
// 	subscriptionUid.value = null;
// 	fbToken.value = null;
// }

const registration = ref(null);
async function registerServiceWorker() {
	try {
		const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });
		if (reg) {
			registration.value = reg;
			console.log('REGISTRATION SW DONE:', reg);
		}
	} catch (err) {
		registration.value = null;
		console.log('REGISTRATION SW FAIL: ', err);
	}
	// return new Promise((resolve, reject) => {
	// 	navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' })
	// 		.then(async (sw) => {
	// 			console.log('registerServiceWorker', sw);
	// 			const navigatorReady = await navigator.serviceWorker.ready; // Here's the waiting
	// 			console.log('navigatorReady:', navigatorReady);
	// 			resolve(sw);
	// 		})
	// 		.catch((err) => {
	// 			console.log('[Service Worker] Registration Error:', err);
	// 			reject(err);
	// 		});
	// });
}
async function getFirebaseToken() {
	console.log('getFirebaseToken', fbToken.value);

	return new Promise((resolve, reject) => {
		if (fbToken.value) {
			fbToken.value = null;
			// unsubscribe() ??
			getToken(messaging, { serviceWorkerRegistration: registration.value, vapidKey: vapidKeyMax }).then((currentToken) => {
				fbToken.value = currentToken;
				resolve(fbToken.value);
			}).catch((error) => {
				clearCookie('webPushHidden');
				clearCookie('contractModal');
				fbToken.value = null;
				reject(error);
			});
		} else {
			resolve(null);
		}
	});
}

const subscribeLoading = ref(false);
// eslint-disable-next-line no-unused-vars
async function subscribe() {
	subscribeLoading.value = true;

	const promise = new Promise((resolve, reject) => {
		getToken(messaging, { serviceWorkerRegistration: registration.value, vapidKey: vapidKeyMax })
			.then((token) => {
				if (token) {
					fbToken.value = token;
					resolve(token);
				} else {
					console.warn('Не удалось получить токен.');
				}
			})
			.catch((err) => reject(err));
	});

	promise
		.then(async (token) => {
			console.log('RESOLVED:', token);
			try {
				const subscribeRes = await store.dispatch('webPush/subscribe', { token });
				console.log('subscribe:', subscribeRes);
				// emit('webpushAfterResetToken', false);
				closeWebpush(false);

				if (page.value !== 'main-page') {
					const yaTargetWebpushStyle = computedWebpushStyle.value === 1 ? 'sub_push_1s' : 'sub_push_2s';
					window.ym(58061740, 'reachGoal', yaTargetWebpushStyle);
				} else if (page.value === 'main-page') {
					window.ym(58061740, 'reachGoal', 'sub_push_contract_s');
				}
			} catch (e) {
				console.log('suscribe error:', e);
			}
		})
		.catch((err) => {
			console.log('REJECTED:', err);
			subscribeLoading.value = false;
			console.warn('При получении токена произошла ошибка.', err);
			webpushSubcribeError.value = true;
		});
}

// eslint-disable-next-line camelcase,no-unused-vars,consistent-return
async function checkSubscription() {
	try {
		const token = await getFirebaseToken();

		if (!token) {
			console.log('hasActiveSub false1');
			// emit('hasActiveSubscribe', false);
			return false;
		}

		const response = await store.dispatch('webPush/checkSubscriptions', { token });
		console.log('webPush/checkSubscriptions:', response);

		if (response.data.data.subscription) {
			console.log('hasActiveSub TRUE');
		} else {
			console.log('hasActiveSub false2');
			emit('webpushAfterResetToken', true);
		}
	} catch (e) {
		console.log('checkSubscriptions error:', e);
	}
}

onMounted(async () => {
	await registerServiceWorker();
	await checkSubscription();
});

</script>

<style lang="scss" scoped>
@import "web-push";
</style>
